import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTable from "react-table";
import _ from 'lodash';
import Underscore from "underscore";
import QueryString from "query-string";
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import VatCodeForm from './vatCodeForm';
import FilterPanel from './FilterPanel';
import ComponentUtil from '../../utils/componentUtil';
import VAT_CODES_CONTROLLER from '../../controllers/vatCodes';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import AppConfig from '../../utils/appConfig';
import AlertBox from '../modals/AlertBox';
import SearchByDetailsForm from '../vatCodeSearchBy/searchByDetailsForm';
import Modal from 'react-responsive-modal';
import FileSaveAs from '../downloaders/FileSaveAs';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import { FileValidationHelper } from '../../utils/helpers';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
import { SSelect } from '@avalara/skylab-sdk/react';

const PAGE_INTERNAL_IDS = [
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID,
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_COUNTRY_CODE,
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_MONTH,
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_YEAR
];

const PAGE_NAME = 'VAT_CODES_PAGE';
const GenericCompanyBody = 'Generic';
const GenericCompanyId=-101;
const log = new Logger(PAGE_NAME, LOG_LEVELS.DEBUG);
const MAX_FILE_SIZE_IN_MB = 5;
const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * AppConfig.UploadConfig.bytesPerKB * AppConfig.UploadConfig.bytesPerKB;

const FULL_PAGE_MODAL_STYLING = { overlay: { fullScreenOverlay: 'white' }, modal: {fullScreenModal: 'white'}, closeIcon: {fullScreenCloseIcon: 'white'}}

function parseQueryParams(string) {
  return QueryString.parse(string, {arrayFormat: 'index'});
}

const vatCodeFlowColumn =  { 
  id: 'vatCodeFlow', 
  accessor: 'vatCodeFlow', 
  filterable: true,
  Header: row => <LanguageStringResolver string="vatCodes_header_flowType"/>,
  Cell: row => {
    // Extract the logic into a simple conditional return
    if (!row.value) {
      return <div></div>;
    }
    return <div>{row.value}</div>;
  },
  filterMethod: (filter, row) => {
    if (filter.value === 'all') {
      return true;
    }
    return row[filter.id].toLowerCase() === filter.value;
  },
  Filter: ({ filter, onChange }) => {
    // Create options list for SSelect
    const flowOptions = [
      { key: 'all', value: 'all', label: 'All', selected: (filter ? filter.value : "all") === 'all' },
      { key: 'in', value: 'in', label: 'In', selected: (filter ? filter.value : "all") === 'in' },
      { key: 'out', value: 'out', label: 'Out', selected: (filter ? filter.value : "all") === 'out' }
    ];

    return (
      <SSelect
        inputId="vat-code-flow-filter"
        optionsList={flowOptions}
        multiple={false}
        style={{ width: "100%" }}
        onS-select={(event) => onChange(event.detail.item.value)}
      />
    );
  }
}
// New Start Date Column

const startDateColumn = {
  id: 'startDate', 
  accessor: 'startDate',
  filterable: true,
  sortable: true,
  Header: row => <LanguageStringResolver string="vatCodes_header_startDate"/>,
  Cell: row => {
    if (!row.value) return null;
    return (
      <div>
        {moment(row.value).format('DD-MM-YYYY')}
      </div>
    );
  },
  filterMethod: (filter, row) => {
    if (!filter.value) {
      return true;
    }

    if (!row[filter.id]) {
      return false;
    }
    const rowDate = moment(row[filter.id]);
    const filterDate = moment(filter.value, 'DD-MM-YYYY');
    if (!rowDate.isValid() || !filterDate.isValid()) {
      return false;
    }
    return rowDate.isSame(filterDate, 'day');
  },
  
  Filter: ({ filter, onChange }) => {
    const handleDateChange = (event) => {
      const value = event.target.value;
      
      // Handle clearing the filter
      if (!value) {
        onChange('');
        return;
      }
     
      if (event.target.type === "date") {
        // Only process if we have a complete date string
        if (value.length === 10) {  
          const formattedDate = moment(value).format('DD-MM-YYYY');
          onChange(formattedDate);
        }
        return;
      }
    };

    // Convert DD-MM-YYYY to YYYY-MM-DD for calendar input
    const calendarValue = filter?.value ? 
      moment(filter.value, 'DD-MM-YYYY').format('YYYY-MM-DD') : 
      '';

    return (
      <div>
        <input
          type="date"
          value={calendarValue}
          onChange={handleDateChange}
          style={{ width: "100%" }}
        />
      </div>
    );
  }
}

export class VatCodesPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
        removeExistingVatCodes: false,
        confirmAction: undefined,
        loading: true,
        showMaxSizeAlert: false,
        openCreateByTransactionId: false,
        openDetailsModal: false,
        openDuplicateModal: false,
    };
    this.doFilterHandler = this.doFilterHandler.bind(this);
  }

  doFilterHandler(selection = {}) {
    log.debug("doFilterHandler - selection: ", selection);
    this.lastSelection = { ...selection };

    const { companyList } = this.props;
    let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();

    let fullQueryParams = Object.assign({}, globalFilterSelection, QueryString.parse(this.props.location.search),selection);
    log.debug("doFilterHandler - fullQueryParams: ", fullQueryParams);

    // TODO SVR-5486 move url cleaning into componentUtil (it appears in code 23 times!)
    let filteredQueryParams = selection;
    PAGE_INTERNAL_IDS.forEach(key => delete filteredQueryParams[key]);
    ComponentUtil.updateUrlParams(this.props.location, this.props.history, filteredQueryParams);

    if (fullQueryParams && fullQueryParams.companyId === 'All') {
      fullQueryParams.companyId = -1;
    }

    // by default All company are selected 
    selection.companyCode = selection.companyCode || 'All';
    let filterBuilderObject = Object.assign({
      userCode: fullQueryParams.companyCode || 'All',
      companyId: fullQueryParams.companyId || -1
    }, selection);

    if (filterBuilderObject.companyId === -1 && filterBuilderObject.companyCode === 'All' && filterBuilderObject.userCode === 'All') {
      filterBuilderObject = {
        ...filterBuilderObject,
        companyList: companyList // Pass the companyList here
      };
    }
    
    //If company is selected then only send the api call for GetVatCodes
    if (!Underscore.isEmpty(globalFilterSelection) && (globalFilterSelection.companyId)){
      //For the Generic companies set the CompanyId to -101
      if(globalFilterSelection.companyId == GenericCompanyBody)
          filterBuilderObject.companyId=GenericCompanyId;
       // if feature flag is missing then hit the API once in global filter is filled with companyId
      if (!this.props.enableAllCompanySearchInVatCodeReport) {
        this.props.doFilterVatCodes(filterBuilderObject);
      }
    }
    // explicit API hit irrespective of filter params , as default params loaded as All company
    if (this.props.enableAllCompanySearchInVatCodeReport) {
      this.props.doFilterVatCodes(filterBuilderObject);
    }
    
  }

  showMaxFileSizeAlert() {
    this.setState({
      showMaxSizeAlert: true
    });
    log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_GENERIC_VATCODES);
    log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_VATCODES);
    log.clearDictionaryError(ALL_MESSAGES.VIRUS_SCAN_FAILED);
    log.clearDictionaryError(this.props.createFailures);
  }

  closeMaxFileSizeAlert() {
    this.setState({
      showMaxSizeAlert: false
    });
  }

  render() {
    log.debug('render(): ', this.props);
    const { openCreateByTransactionId, openDetailsModal, openDuplicateModal } = this.state;
    let selectedCodes = this.props.vatCodesSelection || [];
    let codes = this.props.codes || [];
    this.clearFileImportErrorMessages();
    if (this.props.importFailures)
    {
        if(this.props.importFailures.status === 406)
          log.setDictionaryMessage(ALL_MESSAGES.VIRUS_SCAN_FAILED);
        else {
          let error = this.props.importFailures.message;

          let validationMessage = FileValidationHelper.getFileValidationMessage(error);
          if (validationMessage) {
            log.setDictionaryMessage(validationMessage);
          } else {
            log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_IMPORT_VATCODES, this.props.importFailures.message);
          }
        }
    }
    else
    {
      log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_VATCODES);
      log.clearDictionaryError(ALL_MESSAGES.VIRUS_SCAN_FAILED);
    }

    if (this.props.genericVatCodesImportError)
    {
      log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_IMPORT_GENERIC_VATCODES);
    }
    else
    {
      log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_GENERIC_VATCODES);
    }

    if (this.props.createFailures)
    {
      log.setDictionaryMessage(this.props.createFailures);
    }
    else
    {
      log.clearDictionaryError(this.props.createFailures);
    }

    let columns=[
      { id: 'rowSelector', headerClassName:'overflow-inherit', accessor:'id', filterable: false, sortable: false,
        Header: row => 
          <fieldset>
            <input
              className="checkbox" type="checkbox" 
              ref={element => { this.selectAllVatCodes = element}}
              onClick={this.doSelectAllVatCodes.bind(this)}
            />
            <label className="checkbox"></label>
          </fieldset>,
        Cell: row => 
          <fieldset>
            <input className="checkbox" checked={selectedCodes.includes(row.value)} type="checkbox" onChange={this.props.doToggleVatCodeSelection.bind(this, row.value)} />
            <label className="checkbox"></label>
          </fieldset>},

      { id: 'userCode', accessor:'userCode', filterable: true,
        Header: row => <LanguageStringResolver string="vatCodes_header_company"/>},

      { id: 'vatCode', accessor:'vatCode', filterable: true,
        Header: row => <LanguageStringResolver string="vatCodes_header_vatCode"/>,
        filterMethod: (filter, row) => { return row[filter.id].includes(filter.value)},
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude()
      },
      { id:'Country', accessor:'country', filterable: true,
        Header: row => <LanguageStringResolver string="vatCodes_header_country"/>,
        filterMethod: (filter,row) => { return row[filter.id] === filter.value }
      },
      { id: 'vatRate', accessor:'vatRate',filterable: true, className: 'text-align-right',
        Header: row => <LanguageStringResolver string="vatCodes_header_vatRate"/>,
        Cell: row => {
         if (row.value === "NaN") { return (<div></div>) }
         return (<div>{Number(row.value).toFixed(2)} %</div>)
        }
      },
      { id: 'vatRateType', accessor:'vatRateType', filterable: true,
        Header: row => <LanguageStringResolver string="vatCodes_header_vatRateType"/>,
      },
      { id: 'reversedVATRateDomestic', accessor:'reversedVATRateDomestic', filterable: true, className: 'text-align-right',
        Header: row => <LanguageStringResolver string="vatCodes_header_reversedVatRateDomestic"/>,
        Cell: row => {
          if (typeof row.value !== 'number') { return (<div>{row.value}</div>) }
          return (<div>{Number(row.value).toFixed(2)} %</div>)
        }
      },
      { id: 'combinationIDInvoice', accessor:'combinationIDInvoice', filterable: true, className: 'text-align-right',
        Header: row => <LanguageStringResolver string="vatCodes_header_combinationIDInvoice"/>,
      },
      { id: 'combinationIDCredit', accessor:'combinationIDCredit', filterable: true, className: 'text-align-right',
        Header: row => <LanguageStringResolver string="vatCodes_header_combinationIDCredit"/>,
      },
      { id: 'action', className: 'text-align-center', sortable: false, accessor: 'id', minWidth: 210, width: 210,
        Header: row => <LanguageStringResolver string="vatCodes_header_actions"/>,
        Cell: this.renderActionCell
      },
    ];

    if (this.props.EnableNewVatCodeColumns) {
       // if feature flag is enabled add the new two columns vatCodeFlowColumn, startDateColumn just before the last action column
       columns.splice(columns.length - 1, 0, vatCodeFlowColumn);
       columns.splice(columns.length - 1, 0, startDateColumn);  
    }

    const NoDataComponent = props => (
      <NoData
        noDataText="VATCodes_NoData"
        {...props}
      />
    );

    return(
      <div className="content-area" data-test="component-vatcodes-page">
        <span ref={element => { this.vatCodesView = element}}></span>
        <AlertBox 
          show={this.state.showMaxSizeAlert} 
          messageKey='vatCodes_page_fileSizeAlert' 
          onClose={ () => { this.closeMaxFileSizeAlert(); }}
          messageParams={[MAX_FILE_SIZE_IN_MB]}
         />
        <s-container>
          <ReadOnlyWrapper>
            <h1><LanguageStringResolver string="vatCodes_page_title"/></h1>
            <ApplicationMessages messageType="applicationError"/>
            <ApplicationMessages messageType="applicationWarning"/>
            <ApplicationMessages messageType="applicationSuccess"/>
            <div className="mb20">
              <button className="link" onClick={this.openAddVATCode.bind(this)}><s-icon class="mr5" name="plus" aria-label="plus"></s-icon><LanguageStringResolver string={'vatCodes_add_your_VAT_code'}/></button>
              <span className="divider-left margin-left-sm margin-right-sm"></span>
              <button className="link" onClick={this.pageActionHandler.bind(this,'IMPORT_GENERIC_CODES')}><s-icon class="mr5" name="upload" aria-label="upload"></s-icon><LanguageStringResolver string={'vatCodes_import_generic_VAT_codes'}/></button>
              <span className="divider-left margin-left-sm margin-right-sm"></span>
              <button className="link" onClick={this.showOpenFileDlg.bind(this)}>
                <s-icon class="mr5" name="upload" aria-label="upload"></s-icon>
                <LanguageStringResolver string="vatCodes_import_custom_VAT_codes"/>
                <input type="file" id="file"
                       ref={element => {
                         this.inputOpenFileRef = element
                       }} style={{display: "none"}}
                       onChange={this.onSelectCustomVatCodesFile.bind(this)}
                       accept=".txt"/>
              </button>
              <span className="divider-left margin-left-sm margin-right-sm"></span>
              <FileSaveAs 
                downloadLabelKey="vatCodes_export_VAT_codes" 
                fetchContent={this.onExportVatCodes.bind(this)}
                filename={`VatCodes-${moment.utc().format('YYYY-MM-DD')}`}  
                mimeType="text/plain"
                charset="utf-8"
                isBlob={true}
                excludeFromReadonly={true}
              />
            </div>
            <FilterPanel onSearch={this.doFilterHandler}/>
            <div className="mb20 display-flex">
              <button
                className={(this.props.vatCodesSelection && this.props.vatCodesSelection.length > 0) ? 'link' : 'link disabled'}
                onClick={this.pageActionHandler.bind(this, 'DELETE_SELECTION')}
              ><s-icon class="mr5" name="trash" aria-label="trash"></s-icon> <LanguageStringResolver string={'vatCodes_delete'}/>
              </button>
              <span className="divider-left margin-left-sm margin-right-sm"></span>
              <fieldset>
                <input checked={this.state.removeExistingVatCodes} type="checkbox" onChange={(event) => {this.setState({removeExistingVatCodes: event.target.checked })}} />
                <label className="checkbox clickable"><LanguageStringResolver string={'vatCodes_Delete_Existing'}/></label>
              </fieldset>
            </div>
            <ReactTable
              defaultPageSize={20}
              minRows={0}
              maxRows={0}
              data={codes}
              columns={columns}
              pageSizeOptions={[10,20,50,100,500,1000]}
              onPageChange={this.props.doClearVatCodeSelection.bind(this)}
              onPageSizeChange={this.props.doClearVatCodeSelection.bind(this)}
              onSortedChange={this.props.doClearVatCodeSelection.bind(this)}
              onFilteredChange={this.props.doClearVatCodeSelection.bind(this)}
              ref={element => { this.vatCodesReactTable = element}}
              NoDataComponent={NoDataComponent}
              className={codes.length === 0 ? 'hide-header' : ''}
              PaginationComponent={Pagination}
              showPagination={codes.length === 0 ? false : true}
            />
          {/* Create New Wizard Modal */}
          <Modal
            open={openCreateByTransactionId}
            onClose={this.onCancelOrCloseModal.bind(this)}
            closeOnOverlayClick={false}
            classNames={ FULL_PAGE_MODAL_STYLING }
          >
            <SearchByDetailsForm
              companies={this.props.companyList}
              submitHandler={this.pageActionHandler.bind(this)}
              exitAction={this.onCancelOrCloseModal.bind(this)}
            />
          </Modal>
          {/* View / Edit Modal */}
          <Modal
            open={openDetailsModal}
            onClose={this.onCancelOrCloseModal.bind(this)}
            closeOnOverlayClick={false}
            classNames={ FULL_PAGE_MODAL_STYLING }
          >
            <div>
              {(this.state.detailsVatCode) ? (
              <div>
                <h1 className="mb20"><LanguageStringResolver string={'vatCodes_Details'}/></h1>
                <VatCodeForm
                  createNew='false'
                  userCode={this.state.detailsVatCode.userCode}
                  id={this.state.detailsVatCode.id}
                  vatCode={this.state.detailsVatCode}
                  submitHandler={this.pageActionHandler.bind(this)}
                  cancelHandler={this.onCancelOrCloseModal.bind(this)}
                />
                </div>
              ):(
                <div></div>
              )}
            </div>
          </Modal>

          {/* Duplicate Modal */}
          <Modal
            open={openDuplicateModal}
            onClose={this.onCancelOrCloseModal.bind(this)}
            closeOnOverlayClick={false}
            classNames={ FULL_PAGE_MODAL_STYLING }
          >
            <div>
              {(this.props.duplicateVatCode) ? (
              <div>
                <h1 className="mb20"><LanguageStringResolver string={'vatCodes_Duplicate'}/></h1>
                <VatCodeForm
                  key={this.props.duplicateVatCode.formId}
                  id={this.props.duplicateVatCode.formId}
                  createNew='true'
                  duplicateVatCode='true'
                  userCode="Custom"
                  vatCode={this.props.duplicateVatCode}
                  submitHandler={this.pageActionHandler.bind(this)}
                  cancelHandler={this.onCancelOrCloseModal.bind(this)}
                />
                </div>
              ):(
                <div></div>
              )}
            </div>
          </Modal>
          <div className="clear"></div>
          </ReadOnlyWrapper>
        </s-container>
      </div>
    );
  }

  showOpenFileDlg(){
    if (this.inputOpenFileRef)
    {
      this.inputOpenFileRef.value = '';
      this.inputOpenFileRef.click()
    }
  };

  componentDidMount() {
    log.debug('componentDidMount()');
    log.clearAllDictionaryErrors();

    this.doFilterHandler();
  };

  componentDidUpdate(prevProps){
    // The flag arrives after the first mount, which skips the load while it is unset; load once it turns on,
    // keeping any filter applied since mount.
    if (this.props.enableAllCompanySearchInVatCodeReport && !prevProps.enableAllCompanySearchInVatCodeReport) {
      this.doFilterHandler(this.lastSelection);
    }
    if (this.selectAllVatCodes)
    {
      let selectedVatCodes = (this.props.vatCodesSelection || []);
      this.selectAllVatCodes.checked = _.every(this.getVisibleVatCodes(), c => selectedVatCodes.includes(c));
    }
    if (this.props.failures !== prevProps.failures && this.props.failures)
    {
      log.setDictionaryMessage(this.props.failures);  
      this.vatCodesView && this.vatCodesView.scrollIntoView();
    }
    if(this.props.failures) {
      this.vatCodesView && this.vatCodesView.scrollIntoView();
    }
    
  };

  componentWillUnmount() {
    log.debug('componentWillUnmount() - ');
    //clear VAT codes from state
    this.props.doClearVATCodes();
  };

  onSelectCustomVatCodesFile(event){
    let files = event.target.files[0];
    if(!files) {
      return;
    }
    if(files.size <= MAX_FILE_SIZE_IN_BYTES) {
      let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();    
      this.props.doImportCustomVatCodes(event.target.files[0], this.state.removeExistingVatCodes, {companyId:globalFilterSelection.companyId}); //companyId needed to get vat codes once import is done
    } else {
      this.showMaxFileSizeAlert();
    }
  }

  renderActionCell = (row) => {
    return (
      <ReadOnlyWrapper>
        <span>
          <a className="tertiary" onClick={this.pageActionHandler.bind(this, 'DETAILS', row.original)} excludeFromReadonly={true}>
            <LanguageStringResolver string="vatCodes_action_details"/>
            <span className="divider-left margin-left-sm margin-right-sm"></span>
          </a>
          <a className="tertiary" onClick={this.pageActionHandler.bind(this, 'DELETE', row.value)}>
            <LanguageStringResolver string="vatCodes_action_delete"/>
            <span className="divider-left margin-left-sm margin-right-sm"></span>
          </a>
          <a className="tertiary" onClick={this.doDuplicateVatCode.bind(this, row.value)}>
            <LanguageStringResolver string="vatCodes_action_duplicate"/>
          </a>
        </span>
      </ReadOnlyWrapper>
    );
  }

  pageActionHandler(action, data) {
    log.debug("pageActionHandler: action: %s data: %s ", action, data);
    this.props.doClearErrorMessages();

    let selection = GLOBAL_FILTER_CONTROLLER.getAll();
    let parsedQueryParams = Object.assign({}, parseQueryParams(this.props.location.search),  {
      companyId: (selection[GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID] == GenericCompanyBody)?GenericCompanyId:selection[GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID],
      userCode: selection[GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_CODE]
    });

    switch (action) {
      case 'CREATE_BY_TRANSACTION_ID':
        log.debug("pageActionHandler: CREATE_BY_TRANSACTION_ID");
        this.props.doCreateVatCodeByTransactionId(data,parsedQueryParams);
        this.setState({ openCreateByTransactionId: false });
        break;
      case 'EXPERT_UPDATE':
        log.debug("pageActionHandler: EXPERT_UPDATE");
        this.setState({ openDetailsModal: false });
        this.props.doUpdateVatCode(data, parsedQueryParams);
        break;
      case 'EXPERT_DUPLICATE':
        log.debug("pageActionHandler: EXPERT_DUPLICATE");
        this.setState({ openDuplicateModal: false });
        this.props.doCreateVatCodeByDuplicate(data, parsedQueryParams);
        break;
      case 'DELETE':
        log.debug("pageActionHandler: DELETE");
        this.props.doDeleteVatCode(data, parsedQueryParams);
        break;
      case 'DELETE_SELECTION':
        log.debug("pageActionHandler: DELETE_SELECTION");
        if (this.props.vatCodesSelection && this.props.vatCodesSelection.length > 0)
        {
          this.props.doDeleteMultipleVatCodes(this.props.vatCodesSelection, parsedQueryParams);
        }
        break;
      case 'DETAILS':
        log.debug("pageActionHandler: DETAILS");
        this.setState({ openDetailsModal: true, detailsVatCode: data });
        break;
      case 'IMPORT_GENERIC_CODES':
        this.props.doImportGenericVatCodes(this.state.removeExistingVatCodes, parsedQueryParams);
        break;
      default:
        log.debug("pageActionHandler: Unhandled action: ", action)
    }
  }

  doDuplicateVatCode(id){
    this.setState({ 
      openDuplicateModal: true
    });
    log.clearAllDictionaryErrors();
    let originalCode = this.props.codes.find(c => c.id === id);
    if (originalCode)
    {
      let duplicatedCode = Object.assign({}, originalCode, {id: -1, reporterId: -1, formId: Math.random()});
      this.props.doDuplicateVatCode(duplicatedCode, parseQueryParams(this.props.location.search));
    }
  }

  onCancelOrCloseModal() {
    log.clearAllDictionaryErrors();
    this.props.doCancelDuplicateVatCode(parseQueryParams(this.props.location.search));
    this.setState({
      openCreateByTransactionId: false,
      openDetailsModal: false,
      openDuplicateModal: false
    });
  };

  openAddVATCode() {
    log.clearAllDictionaryErrors();
    this.props.doClearErrorMessages();
    this.setState({ openCreateByTransactionId: true });
  };

  doSelectAllVatCodes(e){
    log.clearAllDictionaryErrors();     
    if(e){
      e.stopPropagation ();
    }
    if (this.selectAllVatCodes)
    {
      if (this.selectAllVatCodes.checked){
        this.props.doSelectVatCodes(this.getVisibleVatCodes(), parseQueryParams(this.props.location.search));
      }
      else{
        this.props.doClearVatCodeSelection();
      }
    }    
  }

  getVisibleVatCodes(){
    const current = this.vatCodesReactTable;
    if (current)
    {
      const page = current.state.page;
      const pageSize = current.state.pageSize;
      const allData = current.getResolvedState().sortedData;
      const startIdx = page * pageSize;
      const currentData = allData.slice(startIdx, startIdx + pageSize).map((item) => item._original);
      
      return currentData.map(c => c.id);
    }
  }

  clearFileImportErrorMessages(){
    log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_VATCODES);
    log.clearDictionaryError(ALL_MESSAGES.VIRUS_SCAN_FAILED);
    log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN);
    log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG);
    log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG);
    log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN);
    log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN);
    log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH);
  }

  onExportVatCodes() {
    log.debug('onExportVatCodes()');
      return new Promise((resolve, reject) => {
        this.props.doExportVatCodes( (err, data) => {
          if(err) {
            reject(err);
            return;
          }
          const downloadData = {
            content: data || '',
            ext: 'txt'
          };
          resolve(downloadData);
        });
      });
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {
    codes: state.vatCodes && state.vatCodes.data,
    duplicateVatCode: state.vatCodes && state.vatCodes.duplicateVatCode,
    failures: state.vatCodes.failures,
    companyList: state.companies && state.companies.data,
    vatCodesSelection: state.vatCodes && state.vatCodes.selectedIds,
    importFailures: state.vatCodes.importFailures,
    createFailures: state.vatCodes.createfailures,
    genericVatCodesImportError: state.vatCodes && state.vatCodes.genericVatCodesImportError,
    EnableNewVatCodeColumns: state.featureFlag?.data?.EnableNewVatCodeColumns,
    enableAllCompanySearchInVatCodeReport: state.featureFlag?.data?.EnableAllCompanySearchInVatCodeReport
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    doFilterVatCodes: (params) => {
      dispatch(VAT_CODES_CONTROLLER.doFilterVatCodes(params));
    },
    doUpdateVatCode: (formData, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doUpdateVatCode(formData, filterParams));
    },
    doCreateVatCodeByTransactionId: (body, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doCreateVatCodeByTransactionId(body, filterParams));
    },
    doCreateVatCodeByDuplicate: (formData, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doCreateVatCodeByDuplicate(formData, filterParams));
    },
    doImportCustomVatCodes: (vatCodesFile, removeExistingVatCodes, filterParams) => {
      log.clearAllDictionaryErrors();
      dispatch(VAT_CODES_CONTROLLER.doImportCustomVatCodes(vatCodesFile, removeExistingVatCodes, filterParams));
    },
    doExportVatCodes: (callback=()=>{}) => {
      log.debug("doExportVatCodes(): ");
      dispatch(VAT_CODES_CONTROLLER.doExportVatCodes(callback));
    },
    doDeleteVatCode: (id, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doDeleteVatCode(id, filterParams));
    },
    doDeleteMultipleVatCodes: (ids, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doDeleteMultipleVatCodes(ids, filterParams));
    },
    doImportGenericVatCodes: (removeExistingVatCodes, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doImportGenericVatCodes(removeExistingVatCodes, filterParams));
    },
    doDuplicateVatCode: (duplicateVatCode, filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doDuplicateVatCode(duplicateVatCode, filterParams));
    },
    doCancelDuplicateVatCode: (filterParams) => {
      dispatch(VAT_CODES_CONTROLLER.doCancelDuplicateVatCode(filterParams));
    },
    doSelectVatCode: (id) => {
      dispatch(VAT_CODES_CONTROLLER.doSelectVatCode(id));
    },
    doToggleVatCodeSelection: id => {
      log.clearAllDictionaryErrors();
      dispatch(VAT_CODES_CONTROLLER.doToggleVatCodeSelection(id));
    },
    doClearVatCodeSelection: () => {
      dispatch(VAT_CODES_CONTROLLER.doClearVatCodeSelection());
    },
    doSelectVatCodes: (vatCodes) => {
      dispatch(VAT_CODES_CONTROLLER.doSelectVatCodes(vatCodes));
    },
    doClearErrorMessages: () => {
      dispatch(VAT_CODES_CONTROLLER.doClearErrorMessages());
    },
    doClearVATCodes: () => {
      dispatch(VAT_CODES_CONTROLLER.doClearVATCodes());
    }
  }
}


export default  authorize({
  name: 'VATCodes',
  resource: connect(mapStateToProps, mapDispatchersToProps)(VatCodesPage)
}, AuthorizedResource, {
  showNotAuthorized: true
});

